import { useQuery } from '@apollo/client'

import {
  GET_STORAGE_LIST,
  GET_STORAGE_SEARCH,
  GET_BRANCH_OFICCES,
  GET_CAR_OWNERS,
  GET_CAR_RENTERS
} from '../../../graphql/AdminQueries'

const GetGraphQlData = (graphqlVariables, loadData) => {
  const storage = useQuery(GET_STORAGE_LIST, {
    variables: graphqlVariables,
    skip: !loadData
  })

  return [storage]
}

// Zoznam uskladneniek: hladanie, filtre aj stranovanie robi server.
// Klient uz netaha cely sklad naraz (bolo cez 18 000 zaznamov).
const GetStorageSearch = (graphqlVariables, loadData) => {
  const storage = useQuery(GET_STORAGE_SEARCH, {
    variables: graphqlVariables,
    skip: !loadData,
    fetchPolicy: 'cache-and-network'
  })

  return [storage]
}

// Ciselniky do filtrov: pobocky, majitelia, najomcovia.
const GetCiselniky = (graphqlVariables, loadData) => {
  const pobocky = useQuery(GET_BRANCH_OFICCES, {
    variables: graphqlVariables,
    skip: !loadData
  })
  const majitelia = useQuery(GET_CAR_OWNERS, {
    variables: graphqlVariables,
    skip: !loadData
  })
  const najomcovia = useQuery(GET_CAR_RENTERS, {
    variables: graphqlVariables,
    skip: !loadData
  })

  return [pobocky, majitelia, najomcovia]
}

export { GetGraphQlData, GetStorageSearch, GetCiselniky }
